"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Blank = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var BlankSteps_1 = require("./BlankSteps");
var mediaobject_1 = require("../mediaobject");
var config_context_1 = require("../_util/config-context");
var forward_ref_with_statics_1 = require("../_util/forward-ref-with-statics");
var image_1 = require("./image");
var heading_1 = require("../heading");
var defaultPictureMap = {
    error: image_1.error,
    open: image_1.open,
    arrears: image_1.arrears,
    permission: image_1.authority,
};
exports.Blank = forward_ref_with_statics_1.forwardRefWithStatics(function Blank(_a, ref) {
    var theme = _a.theme, image = _a.image, title = _a.title, description = _a.description, operation = _a.operation, extra = _a.extra, children = _a.children, bottom = _a.bottom, className = _a.className, props = tslib_1.__rest(_a, ["theme", "image", "title", "description", "operation", "extra", "children", "bottom", "className"]);
    var classPrefix = config_context_1.useConfig().classPrefix;
    if (typeof theme === "string" || image) {
        if (bottom && !Array.isArray(bottom)) {
            // eslint-disable-next-line no-param-reassign
            bottom = [bottom];
        }
        var picture = image === null || image === void 0 ? void 0 : image.background;
        if (typeof theme === "string" && defaultPictureMap[theme]) {
            picture = defaultPictureMap[theme];
        }
        return (react_1.default.createElement("div", tslib_1.__assign({ ref: ref, className: classnames_1.default(classPrefix + "-card", classPrefix + "-blank-page-v2", className) }, props),
            react_1.default.createElement("div", { className: classPrefix + "-blank-page-v2__main" },
                react_1.default.createElement("div", { className: classPrefix + "-blank-page-v2__content" },
                    react_1.default.createElement("div", { className: classPrefix + "-blank-page-v2__logo" }, (image === null || image === void 0 ? void 0 : image.logo) && react_1.default.createElement("img", { src: image.logo, alt: "logo" })),
                    react_1.default.createElement("div", { className: classPrefix + "-blank-page-v2__title" },
                        react_1.default.createElement("h2", { className: classPrefix + "-blank-page-v2__title-zh" }, title || description)),
                    children,
                    react_1.default.createElement("div", { className: classPrefix + "-blank-page-v2__opreate" },
                        operation,
                        extra && react_1.default.createElement("div", { className: classPrefix + "-mt-4n" }, extra))),
                react_1.default.createElement("div", { className: classPrefix + "-blank-page-v2__picture", style: { backgroundImage: "url(" + picture + ")" } })),
            bottom && (react_1.default.createElement("div", { className: classPrefix + "-blank-page-v2__relative" },
                react_1.default.createElement("div", { className: classPrefix + "-blank-page-v2__relative-inner" }, bottom.map(function (item, index) { return (react_1.default.createElement("p", { key: index, className: classPrefix + "-blank-page-v2__relative-item" }, item)); }))))));
    }
    var themeImage = getCustomTheme(theme).image;
    return (react_1.default.createElement("div", tslib_1.__assign({ ref: ref, className: classnames_1.default(classPrefix + "-blank-page", className) }, props),
        react_1.default.createElement(mediaobject_1.MediaObject, { align: "middle", media: react_1.default.createElement("div", { className: classPrefix + "-blank-page__media" },
                react_1.default.createElement("span", { className: classPrefix + "-blank-page__media-bg" }, themeImage.background && (react_1.default.createElement("img", { src: themeImage.background, alt: "" }))),
                react_1.default.createElement("span", { className: classPrefix + "-blank-page__media-gif" }, themeImage.gif && react_1.default.createElement("img", { src: themeImage.gif, alt: "" }))) },
            react_1.default.createElement(heading_1.H4, { className: classPrefix + "-mb-2n" }, description),
            children,
            (operation || extra) && (react_1.default.createElement("div", { className: classPrefix + "-blank-page__op" },
                operation,
                extra && react_1.default.createElement("div", { className: classPrefix + "-mt-4n" }, extra))))));
}, {
    Steps: BlankSteps_1.BlankSteps,
});
exports.Blank.displayName = "Blank";
function getCustomTheme(theme) {
    if (typeof theme === "string") {
        return { image: { background: null, gif: null } };
    }
    return tslib_1.__assign({ image: {} }, theme);
}
//# sourceMappingURL=Blank.js.map